import MaskedIcon from './MaskedIcon';
export default MaskedIcon;